import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import AreaAccessCard from "./AreaAccessCard";
import Accordion from "../../../components/accordian";
import VehicleAccessCard from "./VehicleAccessCard";

interface AccessDetailsProps {
  isFieldsDisabled: boolean;

  checkedBuildingIds: number[];
  setCheckedBuildingIds: Dispatch<SetStateAction<number[]>>;

  vehicleAccessIds: number[];
  setVehicleAccessIds: Dispatch<SetStateAction<number[]>>;
}

const AccessDetails = ({
  isFieldsDisabled,
  checkedBuildingIds,
  setCheckedBuildingIds,
  vehicleAccessIds,
  setVehicleAccessIds,
}: AccessDetailsProps) => {
  const { t } = useTranslation();

  const [selectedKey, setSelectedKey] = useState<string>("1");

  return (
    <div className="bg-white z-10 p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        id="1"
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
            {t("1")}. {t("parkingAccessDetails")}
          </h1>
        }
      >
        <div className="flex flex-col gap-4">
          <VehicleAccessCard
            vehicleAccessIds={vehicleAccessIds}
            setVehicleAccessIds={setVehicleAccessIds}
            isFieldsDisabled={isFieldsDisabled}
          />

          <div className="bg-gray-100 h-[1px]" />

          <AreaAccessCard
            checkedBuildingIds={checkedBuildingIds}
            setCheckedBuildingIds={setCheckedBuildingIds}
            isFieldsDisabled={isFieldsDisabled}
          />
        </div>
      </Accordion>
    </div>
  );
};

export default AccessDetails;
